"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fp64ify = fp64ify;
function fp64ify(a) {
  var hi = Math.fround(a);
  var lo = a - Math.fround(a);
  return new Float32Array([hi, lo]);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvZnA2NC9tYXRoLWZwNjQuanMiXSwibmFtZXMiOlsiZnA2NGlmeSIsImEiLCJoaSIsIk1hdGgiLCJmcm91bmQiLCJsbyIsIkZsb2F0MzJBcnJheSJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUFBZ0JBLE8sR0FBQUEsTztBQUFULFNBQVNBLE9BQVQsQ0FBaUJDLENBQWpCLEVBQW9CO0FBQ3pCLE1BQU1DLEtBQUtDLEtBQUtDLE1BQUwsQ0FBWUgsQ0FBWixDQUFYO0FBQ0EsTUFBTUksS0FBS0osSUFBSUUsS0FBS0MsTUFBTCxDQUFZSCxDQUFaLENBQWY7QUFDQSxTQUFPLElBQUlLLFlBQUosQ0FBaUIsQ0FBQ0osRUFBRCxFQUFLRyxFQUFMLENBQWpCLENBQVA7QUFDRCIsImZpbGUiOiJtYXRoLWZwNjQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gZnA2NGlmeShhKSB7XG4gIGNvbnN0IGhpID0gTWF0aC5mcm91bmQoYSk7XG4gIGNvbnN0IGxvID0gYSAtIE1hdGguZnJvdW5kKGEpO1xuICByZXR1cm4gbmV3IEZsb2F0MzJBcnJheShbaGksIGxvXSk7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/experimental/shader-modules/fp64/math-fp64.js
// module id = 1043
// module chunks = 0